import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel
} from "@/components/ui/form"
import { Input } from "@/components/ui/input";
import { Dropdown } from '../ui/filterSelect';

import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { UserSchema } from "./UserSchema";
import { useEffect, useState } from "react";
import { useApiFetch } from "@/helper/apiFetch";
import { Checkbox } from "../ui/checkbox";
import { useTranslate } from "@/helper/translate";
type UserInfoProps = {
  userId: string;
  onClose: (refresh: boolean) => void;
};


type Lookup = { id: string; name: string };


export function UserInfo({ userId, onClose }: UserInfoProps) {
  const apiFetch = useApiFetch();
  const { translate } = useTranslate();
console.log("UserInfo rendered with userId:", userId);
  const [customers, setCustomers] = useState<Lookup[]>([]);
  const [errorText, setError] = useState<string>("");
  const [isReset, setReset] = useState<boolean>(false);

  const form = useForm<z.infer<typeof UserSchema>>({
    resolver: zodResolver(UserSchema),
    defaultValues: {
      customerId: null,
      company: null,
      userName: "",
      isAdmin: false,
      isActive: true,
      isAutoApprove: false
    }
  });



  const onSubmit = async (values: z.infer<typeof UserSchema>) => {

    try {
      setError("");
      const res = await apiFetch(`/App/SaveUser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });

      if (!res.ok) {
        const e = await res.text();
        setError(translate("ui.failedsave") + e);

      }
      else {

        onClose(true);

      }
    } catch (err) {
      console.error(err);
    }
  }




  useEffect(() => {
    if (userId == "") {
      apiFetch(`/App/GetCustomerLookup?all=true`)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch customers");
          return res.json();
        })
        .then((data) => {
          setCustomers(data);

        })
        .catch((err) => {
          console.error(err);
        });
    }

  }, []);

  useEffect(() => {
    if (userId != "") {
      apiFetch(`/App/GetUser?userId=${userId}`)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch user");
          return res.json();
        })
        .then((data) => {
          form.reset(data);

        })
        .catch((err) => {
          console.error(err);
        });
    }

  }, []);


  return (
    <div className="popCnt p-0">

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-2">

        <div className="bg-white dark:bg-zinc-600 rounded-2xl shadow-lg space-y-4 mx-[-10px] my-1 px-3 py-8">

          <div className="grid-default">
            <FormField
              control={form.control}
              name="userName"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{translate("ui.usernameInfo")}</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                </FormItem>
              )}
            />
            {(userId == "" || isReset) && (
              <FormField
                control={form.control}
                name="newPassword"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>{translate("ui.userPwd")}</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />
            )}
{!form.getValues("isAdmin") && (
            userId != "" ? (
              <FormField
                control={form.control}
                name="company"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>{translate("ui.company")}</FormLabel>
                    <FormControl>
                      <Input {...field} disabled={true} />
                    </FormControl>
                  </FormItem>
                )}
              />
            ) : (<FormField
              control={form.control}
              name="customerId"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{translate("playlist.customer")}</FormLabel>
                  <FormControl>
                    <Dropdown
                      {...field}
                      source={customers}
                      getLabel={(x) => x.name}
                      getValue={(x) => x.id}
                    />
                  </FormControl>
                </FormItem>
              )}
            />)
            )}



            <div className="grid grid-cols-2 gap-2 pt-7">

              <FormField
                control={form.control}
                name="isActive"
                render={({ field }) => (
                  <FormItem className="flex items-center space-x-2">
                    <FormControl>
                      <Checkbox
                        label={translate("ui.active")}
                        checked={!!field.value}
                        onCheckedChange={field.onChange}
                        name={field.name}
                        onBlur={field.onBlur}
                        ref={field.ref} />
                    </FormControl>
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="isAdmin"
                render={({ field }) => (
                  <FormItem className="flex items-center space-x-2">
                    <FormControl>
                      <Checkbox
                        label={translate("ui.admin")}
                        checked={!!field.value}
                        onCheckedChange={field.onChange}
                        name={field.name}
                        onBlur={field.onBlur}
                        ref={field.ref}
                      />
                    </FormControl>

                  </FormItem>
                )}
              />
            </div>
            {!form.getValues("isAdmin") && (
              <FormField
                control={form.control}
                name="isAutoApprove"
                render={({ field }) => (
                  <FormItem className="flex items-center space-x-2 pt-7">
                    <FormControl>
                      <Checkbox
                        label={translate("ui.userAutoApprove")}
                        checked={!!field.value}
                        onCheckedChange={field.onChange}
                        name={field.name}
                        onBlur={field.onBlur}
                        ref={field.ref}
                      />

                    </FormControl>

                  </FormItem>
                )}
              />)}
          </div>
          </div>

          <div className="grid-default grid-cols-4">
            <div>
              {!isReset && userId != "" && (
            <Button className="w-full" type="button" onClick={() => {  setReset(true); }}>{translate("common.reset")}</Button>
              )}
            </div>
            <div></div>
            <Button className="w-full" type="button" onClick={() => { console.log("Cancel clicked"); onClose(false); }}>{translate("common.cancel")}</Button>

            <Button className="w-full" type="submit">{translate("common.save")}</Button>
          </div>
          {(errorText != "") && (
            <div className="text-red-500 mt-2">
              {errorText}
            </div>
          )
          }

        </form>
      </Form>
    </div>

  )
}



